import { api } from "@/lib/api";

const b64ToUint8 = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

const registration = () => Promise.race([
  navigator.serviceWorker.ready,
  new Promise((_, rej) => setTimeout(() => rej(new Error("El service worker no está activo. Recarga la app.")), 6000)),
]);

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await registration().catch(() => null);
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error(isIOS() && !isStandalone() ? "En iPhone primero instala la app en tu pantalla de inicio (iOS 16.4+)." : "Este navegador no soporta avisos.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permiso de notificaciones denegado. Actívalo en la configuración del navegador.");
  const reg = await registration();
  const { data } = await api.get("/push/vapid-public-key");
  const sub = (await reg.pushManager.getSubscription()) || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
  await api.post("/push/subscribe", { subscription: sub.toJSON(), device: navigator.userAgent.slice(0, 120) });
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { subscription: sub.toJSON() }).catch(() => {});
  await sub.unsubscribe();
}
